module.exports = __webpack_public_path__ + "static/media/gs.a1ba2944.jpg";